import type {
    TextStyle
} from "react-native";
import type {
    LinkDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getStateLayerColor
} from "../../../stateLayer/stylesheet";
import {
    webStyle
} from "../../../../utils";

export const useStyles = ({
    isFocusVisible,
    isHovered,
    isPressed,
    radiuses,
    borders,
    colors
}: LinkDynamicStyleType) => {
    const styles = {
        link: {
            backgroundColor: getStateLayerColor({
                overlayColor: "default",
                isHovered,
                isPressed,
                colors
            }),
            color: colors.content.text.link,
            ...webStyle({
                textDecorationThickness: borders.line,
                borderRadius: radiuses.xs
            })
        } as Mutable<TextStyle>
    };

    Object.assign(styles.link, getFocusRingStyle({
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
